module.exports = __webpack_public_path__ + "static/media/office-building-large.3da945fd.webp";